import { tx as translateInterfaceText } from '@/utils/i18n';
import { useLanguage } from '@/hooks/useLanguage';
import { KeyRound, Trash2 } from 'lucide-react';
import { ApiKey } from '@/types/apiKey';
import { ApiKeyStatusBadge } from './ApiKeyStatusBadge';
import { formatExpiry, formatRelativeDate } from './ApiKeyTable';

interface ApiKeyCardMobileProps {
  apiKey: ApiKey;
  onRevoke: (apiKey: ApiKey) => void;
}

export function ApiKeyCardMobile({ apiKey, onRevoke }: ApiKeyCardMobileProps) {
  useLanguage();
  return (
    <div className="border border-[#E5E7EB] rounded-xl bg-white p-4">
      <div className="flex items-start justify-between gap-3">
        <div className="flex items-center gap-3 min-w-0">
          <div className="w-8 h-8 rounded-full bg-blue-50 flex items-center justify-center shrink-0">
            <KeyRound className="w-4 h-4 text-[#437DFF]" />
          </div>
          <div className="min-w-0">
            <p className="text-sm font-medium text-[#111] truncate">{apiKey.name}</p>
            <p className="text-xs text-[#64748B] font-mono truncate">
              {apiKey.prefix}
              <span className="text-[#CBD5E1]">••••••••</span>
            </p>
          </div>
        </div>

        {apiKey.status === 'active' && (
          <button
            onClick={() => onRevoke(apiKey)}
            aria-label={translateInterfaceText("Revogar a chave {value0}", { value0: (apiKey.name) })}
            className="text-[#64748B] hover:text-red-600 transition-colors p-1.5 rounded hover:bg-red-50 shrink-0"
          >
            <Trash2 className="w-4 h-4" />
          </button>
        )}
      </div>

      <div className="mt-3 flex items-center justify-between gap-2">
        <ApiKeyStatusBadge status={apiKey.status} />
        <div className="text-right">
          <p className="text-xs text-[#64748B]">{formatRelativeDate(apiKey.lastUsedAt)}</p>
          <p className="text-xs text-[#94A3B8]">{formatExpiry(apiKey)}</p>
        </div>
      </div>
    </div>
  );
}
